import { NavLink } from 'react-router-dom';

const ITEMS = [
  { label: 'Genel', path: '/', icon: 'ri-dashboard-line' },
  { label: 'İşler', path: '/bugunun-isleri', icon: 'ri-tools-line' },
  { label: 'Tahsilat', path: '/tahsilatlar', icon: 'ri-wallet-3-line' },
  { label: 'Takip', path: '/takip', icon: 'ri-notification-3-line' },
  { label: 'Finans', path: '/finans', icon: 'ri-funds-box-line' },
];

export default function MobileBottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-background-200 bg-white lg:hidden">
      <div className="flex items-center justify-around">
        {ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-semibold ${
                isActive ? 'text-primary-600' : 'text-foreground-400'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <i className={`${item.icon} text-lg ${isActive ? 'text-accent-500' : ''}`} />
                {item.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}